export Manager from "./Manager";
export Extension from "./Extension";
export syncListCompose from "./compose/syncList";
export syncMapCompose from "./compose/syncMap";
export asyncListCompose from "./compose/asyncList";
export asyncMapCompose from "./compose/asyncMap";



// WEBPACK FOOTER //
// ./src/index.js